// Util function used to help generate the keys needed to retrieve data from standard ED KPI API responses
// Example:
// - current value: my_otb_percentage.current
// - reference date value: my_otb_percentage_pickup.2022-01-26
export default function generateOdValueKey(
  odSelectionsService,
  baseKey,
  refDateId = null,
) {
  if (refDateId) {
    return `${baseKey}.${odSelectionsService.refDaysAgoDatesInAPIFormat[refDateId]}`;
  }

  return `${baseKey}.current`;
}
